import React from "react";
import {
  buildProductJsonLdString,
  ProductJsonLdInput
} from "../../utils/productJsonLd";

export interface ProductJsonLdProps extends ProductJsonLdInput {
  /** Optional id so each card's schema block is individually addressable/scoped. */
  id?: string;
}

/**
 * HIM-4785 — renders a single pre-rendered `application/ld+json` Product block.
 *
 * Server-rendered inside each product card so the schema ships in the initial HTML and is
 * scoped per card (one `<script>` per card on multi-card pages). Renders nothing when there
 * is no product name to describe. Content is HTML-stripped and `<` is escaped in the builder,
 * so `dangerouslySetInnerHTML` cannot inject markup or break out of the script tag.
 */
export const ProductJsonLd: React.FC<ProductJsonLdProps> = ({ id, ...input }) => {
  const json = buildProductJsonLdString(input);
  if (!json) {
    return null;
  }
  return (
    <script
      type="application/ld+json"
      {...(id ? { id } : {})}
      dangerouslySetInnerHTML={{ __html: json }}
    />
  );
};

export default ProductJsonLd;
